export const getEditThumbnailIsShowing = ({ editThumbnail }) =>
  editThumbnail.isShowing;

export const getEditThumbnailSelectedRecordingId = ({ editThumbnail }) =>
  editThumbnail.recordingId;
